// extracted by mini-css-extract-plugin
export default {"container":"treadwell-ai-solid-icon__container___l6tJq"};